import React from "react";
import ButtonCestParIci from "../divers/ButtonCestParIci";

export default function QuestionDevis() {
  return (
    <div className="border-top pb-5" id="question-devis">
      <div className="mt-5">
        <div className="row justify-content-center">
          <div className="col-10 col-lg-4  text-center">
            <div className="titre_footer text_blue">Une question ?</div>
            <p>Un renseignement sur mes services. </p>
            <div className="row justify-content-center">
              <div className="col-xxl-3 col-xl-4 col-lg-5 col-sm-3 col-6 mx-auto">
                <ButtonCestParIci lienCestParIci={"/contactez-moi/"} />
              </div>
            </div>
          </div>
          <div className="col-10 col-lg-4 mt-5 mt-lg-0 text-center">
            <div className="titre_footer text_blue">FAQ</div>
            <p>Quelques réponses à vos principales questions.</p>
            <div className="row justify-content-center">
              <div className="col-xxl-3 col-xl-4 col-lg-5 col-sm-3 col-6">
                <ButtonCestParIci lienCestParIci={"/faq/"} />
              </div>
            </div>
          </div>
          {/* <div className="col-10 col-lg-4 mt-5 mt-lg-0 text-center">
            <div className="titre_footer text_blue">
              Un devis sur-mesure ?
            </div>
            <p>
              Besoin d'un devis pour un projet. <br />
              J'y répondrais dans les plus bref délais.
            </p>
            <div className="row justify-content-center">
              <div className="col-xxl-3 col-xl-4 col-lg-5 col-sm-3 col-6">
                <ButtonCestParIci lienCestParIci={"/demandez-votre-devis"} />
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
}
